var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4515_13057)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_4515_13057)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_4515_13057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13086 11.7218C10.6961 9.63485 12.783 5.46094 21.6513 5.46094C29.094 5.46094 33.7331 5.46094 39.3276 5.46094C44.9222 5.46094 49.4091 8.41746 50.9743 11.7218",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.4375C24.1759 17.4375 19.4375 22.1759 19.4375 28C19.4375 33.8241 24.1759 38.5625 30 38.5625C35.8241 38.5625 40.5625 33.8241 40.5625 28C40.5625 22.1759 35.8241 17.4375 30 17.4375ZM33.5191 22.3211C34.2471 22.3221 34.9584 22.5389 35.5632 22.9441C36.1679 23.3492 36.639 23.9246 36.9169 24.5974C37.1948 25.2702 37.267 26.0103 37.1243 26.7241C36.9817 27.438 36.6307 28.0935 36.1156 28.6079C35.6005 29.1223 34.9445 29.4724 34.2304 29.614C33.5164 29.7557 32.7764 29.6825 32.104 29.4037C31.4316 29.1249 30.8569 28.653 30.4525 28.0477C30.0482 27.4423 29.8324 26.7307 29.8324 26.0028C29.8328 25.519 29.9284 25.0399 30.1138 24.5931C30.2993 24.1462 30.5709 23.7403 30.9133 23.3984C31.2556 23.0565 31.662 22.7854 32.1091 22.6006C32.5562 22.4158 33.0353 22.3208 33.5191 22.3211ZM25.643 23.6597C26.2386 23.6605 26.8206 23.8379 27.3154 24.1694C27.8103 24.5009 28.1957 24.9716 28.4231 25.5221C28.6505 26.0726 28.7096 26.6782 28.5929 27.2622C28.4762 27.8463 28.189 28.3827 27.7675 28.8036C27.3461 29.2244 26.8093 29.5109 26.2251 29.6268C25.6409 29.7427 25.0354 29.6828 24.4852 29.4547C23.935 29.2266 23.4648 28.8405 23.134 28.3452C22.8031 27.8499 22.6266 27.2677 22.6266 26.6721C22.6268 26.2762 22.705 25.8842 22.8567 25.5186C23.0084 25.1529 23.2306 24.8208 23.5107 24.541C23.7909 24.2613 24.1233 24.0395 24.4892 23.8883C24.855 23.7371 25.2471 23.6594 25.643 23.6597ZM21.7912 31.5308C23.0354 30.8559 24.6284 30.5182 25.643 30.5182C26.4047 30.5182 27.3858 30.6706 28.3511 31.0362C27.704 31.3973 27.1207 31.8624 26.6246 32.4129C25.9548 33.1746 25.5704 34.0846 25.5704 34.9941V35.7558C23.8884 34.7925 22.5629 33.3114 21.7912 31.5334V31.5308ZM30 36.9375C28.9718 36.9383 27.9512 36.7609 26.9836 36.4129V35.0393C26.9836 32.3687 31.3381 31.023 33.5191 31.023C34.6871 31.023 36.4838 31.4105 37.897 32.1813C37.1365 33.6163 35.9996 34.8172 34.6084 35.6551C33.2172 36.493 31.6241 36.9363 30 36.9375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4515_13057",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4515_13057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4515_13057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4515_13057",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4515_13057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4515_13057",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173913,
    stopColor: "#6775F8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6775F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriends);
export default __webpack_public_path__ + "static/media/invite_friends.1e480c21a856ad83c7ba86f54ed4d37c.svg";
export { ForwardRef as ReactComponent };